import { getSelectedLanguage } from 'libs/context'
import { translations } from './translations'

const translate = (key) => {
    const cookieLang = getSelectedLanguage()
  
    const language = {
        'en': 'en_NL',
        'de': 'de_DE',
        'fr': 'fr_BE',
        'nl': 'nl_NL',
        'nb': 'nb_NO',
        'no': 'nb_NO',
        'it': 'it_IT',
        'es': 'es_ES'
    }[cookieLang]
  
    const defaultKey = `### ${key} ###`
  
    const t = translations[language]
  
    if (!t) {
        console.error(`language '${cookieLang}' not supported`)
        return defaultKey
    }
  
    if (t[key]) return t[key]
    else {
        console.error(`Missing translation for '${key}'`)
        return defaultKey
    }
}
  
export default translate

